import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('bicValidator', bicValidator);

    /**
     * Validate Bank BIC values
     *
     * @see http://networking.mydesigntool.com/viewtopic.php?tid=307&id=31
     * @author flzemke.btc
     * @ngInject
     */
    function bicValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function bicValidator(ngModelValue) {
                    if (!ngModelValue) {
                        ctrl.$setValidity('bicValidator', true);
                        return ngModelValue;
                    }

                    return !!ngModelValue.match(
                        /^[A-Za-z]{6}[A-Za-z0-9]{2}(?:[A-Za-z0-9]{3})?$/
                    );
                }

                ctrl.$validators.bicValidator = bicValidator;
            }
        };
    }
})();
